module.exports = __webpack_public_path__ + "img/beginners-series_1x1_poster.4874e04.jpg";